import { render, staticRenderFns } from "./SuggestionList.vue?vue&type=template&id=a7bcac5e&scoped=true"
import script from "./SuggestionList.vue?vue&type=script&lang=ts"
export * from "./SuggestionList.vue?vue&type=script&lang=ts"
import style0 from "./SuggestionList.vue?vue&type=style&index=0&id=a7bcac5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bcac5e",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/input-form-suggestion/suggestion-list.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Finput-form-suggestion%2FSuggestionList.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports